import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';
import { Chip } from '@mui/material';

function SessionsRemainingChip() {
  const { t } = useTranslation(['labels']);
  const activePayments = useSelector((state) => state.clientPayment.data.activePayments) || [];

  return (
    <Field name="payment_id">
      {({ input }) => {
        const selectedPayment = activePayments.find((p) => p.id === input.value);

        return selectedPayment ? (
          <Chip
            label={`${selectedPayment.sessions_remaining} ${selectedPayment.sessions_remaining === 1 ? t('session', { ns: 'labels' }) || 'sesión' : t('sessions', { ns: 'labels' }) || 'sesiones'}`}
            size="small"
            sx={{
              backgroundColor: selectedPayment.sessions_remaining > 0 ? 'success.main' : 'error.main',
              color: 'common.white',
              fontWeight: 600,
              ml: 2,
              mt: '20px'
            }}
          />
        ) : null;
      }}
    </Field>
  );
}

export default SessionsRemainingChip;
